export default {
  computed: {
    // Returns the current timezone as a string
    currentTimeZone() {
      return new Date().toLocaleTimeString('en-us',{timeZoneName:'short'}).split(' ')[2];
    },
  },
  methods: {
    // Converts a date string to an ISO string
    toIsoString(dateString) {
      return dateString ? new Date(dateString).toISOString() : new Date().toISOString();
    },
    // Truncates an ISO string to include date and time but not timezone
    truncateToDateTime(date) {
      date = this.toIsoString(date);
      return date?.slice(0, 16);
    },
    // Returns the publication year for a date value. Date-only values
    // (YYYY-MM-DD) are parsed as midnight UTC and can roll back a year in
    // timezones west of UTC, so read the year straight from the string.
    publicationYear(date) {
      if (!date) return '';
      if (typeof date === 'string') {
        const dateOnlyMatch = /^(\d{4})-\d{2}-\d{2}$/.exec(date);
        if (dateOnlyMatch) return Number(dateOnlyMatch[1]);
      }
      return new Date(date).getFullYear();
    }
  },
}